import { render } from "./CreateTaskView.vue?vue&type=template&id=1bdde7f8"
import script from "./CreateTaskView.vue?vue&type=script&lang=js"
export * from "./CreateTaskView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__